<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: dee
 * @LastEditTime: 2022-10-25 15:32:26
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
 <template>
  <div :class="['mymodal', `modal-${$setting.name}`, { animate: value && message.animate }]" :style="{ backgroundColor: message.bgColor }" v-show="value">
    <div class="info">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <div :class="['msg-info',message.prizeType=='sign'?'sign':'']" :style="infoStyle">
        <template v-if="message.prizeType=='sign'">
          <div class="msgTitle">我的预约</div>
          <div class="tip">
            <div >访客姓名：<span>{{ message.name }}</span></div>
            <div >手机号码：<span>{{ message.mobile }}</span></div>
            <div >同行人数：<span>{{ message.userCount }}人</span></div>
            <div >预约时间：<span>{{$util.parseTime(message.appointmentDate,'{y}-{m}-{d}')}}</span></div>
          </div>
          <img class="qrCode" :src="message.prizeOffQrCode" />
          <div class="code">{{ message.prizeOffCode }}</div>
          <div class="mess">到访时出示二维码签到</div>
        </template>
        <template v-else-if="message.prizeType != 3">
          <div class="msgTitle">兑奖二维码</div>
          <img class="qrCode" :src="message.prizeOffQrCode" />
          <div class="code">{{ message.prizeOffCode }}</div>
          <div class="tip">
            <div v-if="message.prizeName">奖品名称：{{ message.prizeName }}</div>
            <div v-if="message.time">领奖时间：{{ message.time }}</div>
            <div v-if="message.address">领奖地址：{{ message.address }}</div>
            <div v-if="message.receiveStartTime&&message.receiveEndTime">领奖有效期：<br/>{{message.receiveStartTime|parseTime}} ~ {{message.receiveEndTime|parseTime}}</div>
          </div>
        </template>
        <template v-else>
          <div class="code" style="text-align: center" v-if="message.cardNo">兑换码:<br />{{ message.cardNo }}</div>
          <div class="tip">
            <div style="text-align: center" v-if="message.cardNo">请根据活动规则至指定平台兑换</div>
            <template v-else>
              <div style="text-align: center">已充值进您的账户</div>
              <div style="text-align: center">请至相关平台登录账户后查看</div>
            </template>
          </div>
        </template>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";

export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      configInfo: {},
      text: "",
    };
  },
  filters: {
     parseTime(time){
      if (arguments.length === 0 || !time) {
        return null
      }
      const format ='{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (typeof time === 'string') {
          if (/^[0-9]+$/.test(time)) {
            // support "1548221490638"
            time = parseInt(time)
          } else {
            // support safari
            time = time.replace(new RegExp(/-/gm), '/')
          }
        }

        if (typeof time === 'number' && time.toString().length === 10) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      return format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        if (key === 'a') {
          return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
      })
    }
  },
  watch: {},
  computed: {
    infoStyle() {
      if (this.$setting.name == "blindbox") {
        let  borderColor=this.$configInfo.buttonBackgroundColour
        
        if([3,4,5].includes(parseInt(this.$configInfo.uiExt.uiExtTemplate))){
          borderColor=this.$configInfo.backgroundColour
        }
        return {
          backgroundColor: this.$configInfo.popupBackgroundColour,
          borderColor: borderColor,
          "border-radius": 0,
        };
      }
      return {
        backgroundColor: this.$configInfo.popupBackgroundColour,
      };
    },
  },
  mounted() {
    this.configInfo =this.$configInfo 
  },
  methods: {
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  &.modal-blindbox {
    .msg-info {
      border-style:solid;
      border-width:12px 12px 18px;
      position:relative;
      &::after {
        content:'';
        position:absolute;
        bottom:-7px;
        left:0;
        right:0;
        height:8px;
        background: url(https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/circle-line.png?v=20220124) no-repeat center;
        background-size:100% auto;
      }
    }
  }

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;
        padding-top: 16px;

        &.sign{
          .tip{
            font-size: 14px;
            line-height: 24px;
            color: #8C8C8C;
            span{
              color:#262626
            }
          }
          .mess{
            font-size: 14px;
            line-height: 22px;
            color:#777777; 
          }
        }
      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
      }

      .qrCode {
        width: 160px;
        margin-top: 12px;
      }

      .code {
        font-size: 18px;
        line-height: 24px;
        color: #000000;
        font-weight: 500;
        padding:0 20px;
        word-wrap: break-word;
        word-break: break-all;
      }

      .tip {
        width: 240px;
        margin-top: 10px;
        font-size: 12px;
        line-height: 20px;
        color: #595959;
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
